import Alert from '@mui/material/Alert';
import { utils } from 'ethers';
import React, { useState, useContext } from 'react';
import { observer } from 'mobx-react';
import { ServicesContext } from '../../../context-providers/ServicesProvider';
import { tokenDecimals } from '../../../helpers/config/contracts.config';
import { hardcodedErrorCodes } from '../../../helpers/error-message.helper';
import { stakeBalanceStore } from '../../../stores/StakeBalanceStore';
import AmountInput from '../../AmountInput/AmountInput';
import NereusButton from '../../NereusButton/NereusButton';
import StatusIcon from '../../StatusIcon/StatusIcon';
import ModalWrapper from '../ModalWrapper/ModalWrapper';

import './StakeWithdrawDialog.scss';
import {depositWithdrawalStakeStore} from "../../../services/deposit-withdrawal-stake/deposit-withdrawal-stake.store";
import {ContractContext} from "../../../context-providers/ContractsProvider";
import {useAccount} from "wagmi";

const buttonTexts = {
    withdraw: 'Confirm Withdraw',
    withdrawing: 'Withdrawing NRS',
    enterAmount: 'Enter Amount',
    insufficientFunds: 'Insufficient Funds'
};

const StakeWithdrawDialog: React.FC = observer(() => {

    const [amount, setAmount] = useState<string>('0');
    const [isPending, setIsPending] = useState<boolean>(false);
    const { depositWithdrawStakeService } = useContext(ServicesContext);
    const { nrsWithdrawalTimelockContract } = useContext(ContractContext);
    const { address: userAddress } = useAccount();

    let error = null
    if (amount && Number(amount) > Number(stakeBalanceStore.nrsAvailableBalanceDecimal)) {
        error = hardcodedErrorCodes.FE_NOT_ENOUGH_WITHDRAWABLE_BALANCE;
    }

    const btnDisabled = !Number(amount) || !!error

    let buttonText = buttonTexts.withdraw
    if (!amount || Number(amount) === 0) {
        buttonText = buttonTexts.enterAmount
    } else if (error === hardcodedErrorCodes.FE_NOT_ENOUGH_WITHDRAWABLE_BALANCE) {
        buttonText = buttonTexts.insufficientFunds;
    }
    if (isPending) {
        buttonText = buttonTexts.withdrawing
    }

    const handleWithdraw = async () => {
        if (!amount) {
            return;
        }

        setIsPending(true);
        try {
            await depositWithdrawStakeService.withdraw(utils.parseUnits(amount, tokenDecimals.nrs));
            if (userAddress) {
                depositWithdrawalStakeStore.fetchWithdrawals(nrsWithdrawalTimelockContract, userAddress)
            }
        } catch {}
        setIsPending(false);
    }

    return (<ModalWrapper className="WithdrawDialog"
                          headerChildren={<h2 className="nereus-body-m">Request Withdrawal</h2>}
                          bodyChildren={<div className="WithdrawDialog__body">
                              <AmountInput label="Amount" asset="NRS"
                                           hasMaxButton={true}
                                           value={amount}
                                           available={stakeBalanceStore.nrsAvailableBalanceDecimal}
                                           onChange={amount => setAmount(amount === '' ? '0' : amount + '')}/>
                              {error &&
                                  <Alert className="WithdrawDialog__error mt-4" variant="standard" severity="error">
                                      <span className="nereus-caption">{error}</span>
                                  </Alert>}
                              <Alert className="WithdrawDialog__error mt-4" variant="standard" severity="info">
                                  <span className="nereus-caption"><span className="nereus-color-main">Withdrawals will be available for claiming after a 30-day redemption period.</span> Please note, rewards will not accrue on the requested withdrawal amount during this period.</span>
                              </Alert>
                              <div className="flex pb-4 mt-4">
                                  <NereusButton disabled={btnDisabled || isPending} variant="contained"
                                                onClick={handleWithdraw}
                                                className="bg-light-green text-dark-blue w-full">
                                      {buttonText} {isPending && <StatusIcon className="ml-1 inline" status="disabled-pending" />}
                                  </NereusButton>
                              </div>
                          </div>}
    />);
});

export default StakeWithdrawDialog;
